import React from "react";

// hooks
import { useWindowSize } from "../../hooks/use-window-size/use-window-size";

// components
import Modal from "../modal/Modal";
import Button from "../button/Button";

// styles
import styles from "./ConfirmModal.module.scss";

type ConfirmModalProps = {
  isOpen: boolean;
  modalTitle: string;
  modalText: string;
  onClose: () => void;
  onSubmit: () => void;
};

export function ConfirmModal({
  isOpen,
  modalTitle,
  modalText,
  onClose,
  onSubmit,
}: ConfirmModalProps) {
  const { width } = useWindowSize();

  return (
    <Modal
      isOpen={Boolean(isOpen)}
      onClose={onClose}
      header={modalTitle}
      width={width > 767 ? "40%" : "97%"}
      className={styles.modal}
    >
      <form className={styles.form}>
        <div className={styles.textWrapper}>
          <p>{modalText}</p>
        </div>
        <div className={styles.buttonswWrapper}>
          <Button
            onClick={onClose}
            variant="outline"
            className={styles.cancelButton}
          >
            Cancel
          </Button>
          <Button onClick={onSubmit} type="submit">
            Delete
          </Button>
        </div>
      </form>
    </Modal>
  );
}
